<div class="relative flex h-full flex-col" *transloco="let t">
  <ITabs [tabs]="catalogTabs()" [activeTab]="selectedTab()" (activeTabChange)="activeTabChanged($event!)" />

  @if (selectedTab() === CatalogTab.MANAGED) {
    <app-managed-catalog-page
      class="flex h-full flex-col"
      [currencyCode]="currencyCode()"
      [currency]="currencyEx()"
      [locale]="locale()"
    />
  }
  @if (selectedTab() === CatalogTab.UNMANAGED) {
    <app-unmanaged-catalog-page class="flex h-full flex-col" />
  }
</div>
